import { IModelEntity } from '@pit/core';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoResourceType extends IModelEntity {

    code?: string;
    description?: string;

    mandator?: IDtoMandator;

}
